import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { OFFER_ANCHOR, previewImages } from '../data/product';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-tech px-4 py-4 sm:py-6" data-id="element-123" data-mp="3am5b3yjmxvfw">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="3amx3z1lulf2h">
        <p className="text-center font-head text-[12px] font-bold uppercase tracking-[0.2em] text-volt sm:text-sm" data-id="element-125" data-mp="3fl8g5izm81nv">
          LOOK INSIDE
        </p>
        <h2 className="mt-0.5 text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-126" data-mp="3kcqgc4ttdy7s">
          Discover What’s Inside INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™
        </h2>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-carbon/80" data-id="element-127" data-mp="3tc3q6yluoot1">
          Visual troubleshooting maps, diagnostic sequences, inspection points,
          decision trees, mechanical references, hydraulic and pneumatic
          diagnostics, sensor checks and ready-to-use field tools.
        </p>

        <div className="relative mt-2" data-id="element-128" data-mp="23zjj9jqt4dxe">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Preview of the material inside INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO" data-id="element-129" data-mp="28wia9tf6c4rd">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-130" data-mp="2au07g3t23wy0">
                <a href={OFFER_ANCHOR} className="block" data-id="element-131" data-mp="2as6z8k2sp4nw">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-md border-2 border-navy bg-white shadow-2xl" data-id="element-132" data-mp="25u5elupq0xab" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-volt text-navy shadow-lg transition-colors duration-150 hover:bg-white disabled:pointer-events-none disabled:opacity-0" data-id="element-133" data-mp="2tk86a9pq418e">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="3h61yv2crpfjk" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-volt text-navy shadow-lg transition-colors duration-150 hover:bg-white disabled:pointer-events-none disabled:opacity-0" data-id="element-135" data-mp="3m6ga0t9o15lt">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-136" data-mp="2ph8kzb9u8ed5" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-2" data-id="element-137" data-mp="2ti2b8bar6597">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to image ${i + 1} of ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-volt' : 'w-2 bg-steel/40 hover:bg-steel'}`} data-id="element-138" data-mp="2fju79jfau3oj" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}